export const randomKey = () => {
  const rand1 = Math.floor(Math.random() * 10000001);
  const rand2 = Math.floor(Math.random() * 10000001);
  return `${rand1}${rand2}`;
}